import "./ListView.css";
import "antd/dist/antd.css";

import { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { Table, Tag, Switch as SwitchOption, Tooltip } from "antd";
import { isArray, isEmpty, set } from "lodash";
import { getTask } from "~/util/util";

import { userSelector } from "../../redux/Selectors";
import { TaskRoutes, StatusesRoutes } from "../../http/routes";
import { ToastContext } from "~/providers/ToastProvider";
import {
  CalendarOutlined,
  ProjectOutlined,
  CaretDownOutlined,
  CaretRightOutlined,
  ClockCircleTwoTone,
} from "@ant-design/icons";

import Modal from "antd/lib/modal/Modal";
import ModalCreateTask from "~/pages/CreateTask/ModalCreateTask";

import Breadcrumb from "~/components/Breadcrumb/Breadcrumb";
import CheckPermission from "~/components/CheckPermission";
import checkPermission from "~/helpers/checkPermission";
import DrawerTask from "../../components/DrawerTask/DrawerTask";
import Select from "antd/lib/select";

import ToastComponent from "../../components/ToastComponent/ToastComponent";

const backRoute = "/home/projects/kanban";

function ListView() {
  const [tasks, setTasks] = useState("");
  const [allTasks, setAllTasks] = useState("");
  const [idList, setIdList] = useState([]);
  // const [allIdList, setAllIdList] = useState([]);
  const [selectedId, setSelectedId] = useState([]);
  const [taskFiltered, setTaskFiltered] = useState([]);

  // const [switchLabelColor, setSwitchLabelColor] = useState("grey");
  // const [checkedAllTasks, setCheckedAllTasks] = useState(
  //   checkPermission("visualizar-todas-tarefas") ? true : false,
  // );

  const [groupedTasks, setGroupedTasks] = useState([]);
  const [selectedTask, setSelectedTask] = useState({});
  const [modalShow, setModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isTaskDrawerLoading, setIsTaskDrawerLoading] = useState(false);
  const [modalIsOpen, setModalState] = useState(false);
  const [reload, setReload] = useState(false);
  const [taskEditingData, setTaskEditingData] = useState(null);
  const [columns, setColumns] = useState({});

  const [error, setError] = useState({ hasError: false, message: "" });

  const { setToast } = useContext(ToastContext);

  const userStore = useSelector(userSelector);
  // const { companyId } = useSelector((state) => state.userStore);

  const { push } = useHistory();
  const { Option } = Select;

  const handleModal = () => {
    setModalState((m) => !m);
  };

  const closeCreateModal = () => {
    setReload(() => true);

    setTimeout(() => setReload(() => false), 300);
    setTaskEditingData(null);
    handleModal();
  };

  const handleClose = () => {
    setError({ message: "", hasError: false });
  };

  async function handleRowClick(id) {
    try {
      setIsTaskDrawerLoading(true);
      setModalShow(true);
      const res = await TaskRoutes.getTask(userStore.subprojectId, id);
      const task = res.data.data;
      setSelectedTask(task);
      task.statuses = columns;

      setIsTaskDrawerLoading(false);
    } catch (err) {
      setModalShow(false);
      setToast({
        type: "error",
        title: "Erro!",
        message: "Um erro ocorreu ao exibir a tarefa selecionada!",
        show: true,
        autohide: true,
      });
    }

    setIsTaskDrawerLoading(false);
  }

  function handleOnRow({ id, subproject_id }) {
    return {
      onClick: () => handleRowClick(id, subproject_id),
    };
  }

  const columnsGrouped = [
    {
      title: (
        <span>
          <strong>{"Visualização em Lista"}</strong>
        </span>
      ),
      dataIndex: "name",
    },
  ];

  const initialColumns = [
    {
      //title: "Prioridade",
      dataIndex: "priority_id",
      key: "priority_id",
      align: "start",
      width: "5%",
      render: renderPriorityColor,
      showTitle: false,
      ellipsis: false,
      defaultSortOrder: "ascend",
      sorter: (a, b) => compareByAlph(a.priority_id, b.priority_id),
    },
    {
      title: "ID",
      dataIndex: "id",
      width: "7%",
      align: "center",
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: "Data início",
      dataIndex: "start_date_formatted",
      align: "center",
      render: renderColumn,
      showTitle: true,
      ellipsis: true,
      sorter: (a, b) => a.start_date - b.start_date,
    },
    {
      //title: "Descrição",
      dataIndex: ["due_date", "date_closed"],
      align: "center",
      width: "3%",
      render: renderOverdueClock,
      showTitle: false,
      ellipsis: false,
      /*       sorter: (a, b) => compareByAlph(a.description, b.description),
       */
    },
    /*  {
      title: "Subprojeto",
      dataIndex: "subproject_name",
      align: "center",
      render: renderColumn,
      showTitle: true,
      ellipsis: true,
      sorter: (a, b) => a.subproject_name.localeCompare(b.subproject_name),
    }, */
    {
      title: "Título",
      dataIndex: "name",
      align: "center",
      render: renderColumn,
      showTitle: true,
      ellipsis: true,
      width: "15%",
      sorter: (a, b) => compareByAlph(a.name, b.name),
    },
    {
      title: "Responsável",
      dataIndex: "responsible_name",
      align: "center",
      render: renderColumn,
      showTitle: true,
      ellipsis: true,
      sorter: (a, b) => compareByAlph(a.responsible_name, b.responsible_name),
    },

    {
      title: "Setor",
      dataIndex: "sector_name",
      align: "center",
      render: renderColumn,
      showTitle: true,
      ellipsis: true,
      /* sorter: (a, b) => compareByAlph(a.sector_name, b.sector_name), */
    },
    {
      title: "Serviço",
      dataIndex: "service_name",
      align: "center",
      render: renderColumn,
      showTitle: true,
      ellipsis: true,
      /*       sorter: (a, b) => compareByAlph(a.service_name, b.service_name),
       */
    },
    {
      title: "Inventário",
      dataIndex: "inventory_name",
      align: "center",
      render: renderColumn,
      showTitle: true,
      ellipsis: true,
      /*       sorter: (a, b) => compareByAlph(a.inventory_name, b.inventory_name),
       */
    },

    /*  {
      title: "Tempo de execução",
      dataIndex: "worked_time_formatted",
      align: "center",
      render: renderColumn,
      showTitle: true,
      //      sorter: (a, b) => a.worked_time - b.worked_time,
       
    }, */
    {
      title: "Descrição",
      dataIndex: "description",
      align: "center",
      width: "25%",
      render: renderColumn,
      showTitle: true,
      ellipsis: true,
      /*       sorter: (a, b) => compareByAlph(a.description, b.description),
       */
    },
    /*     {
      title: "Prioridade",
      dataIndex: "priority_id",
      key: "priority_id",
      align: "center",
      render: renderPriority,
      showTitle: true,
      ellipsis: false,
      defaultSortOrder: "ascend",
      sorter: (a, b) => compareByAlph(a.priority_id, b.priority_id),
    }, */
  ];

  function renderOverdueClock(_, data) {
    const { due_date, date_closed } = data;
    const today_date = new Date().getTime();
    if (date_closed == null && due_date != null && due_date < today_date)
      return (
        <span>
          <Tooltip title="Tarefa atrasada!">
            <ClockCircleTwoTone
              style={{ fontSize: "1.2rem" }}
              twoToneColor="#EB5757"
              className="align-middle"
            />
          </Tooltip>
        </span>
      );
  }

  function renderColumn(text) {
    if (text) return text;
    return "-";
  }

  // function renderPriority(priority_id) {
  //   let color;
  //   let name;
  //   switch (priority_id) {
  //     case 0: {
  //       color = "default";
  //       name = "Sem prioridade";
  //       break;
  //     }
  //     case 1: {
  //       color = "processing";
  //       name = "Baixa";
  //       break;
  //     }
  //     case 2: {
  //       color = "warning";
  //       name = "Moderado";
  //       break;
  //     }
  //     case 3: {
  //       color = "error";
  //       name = "Urgente";
  //       break;
  //     }
  //     default:
  //       return "-";
  //   }

  //   return (
  //     <Tag color={color} key={priority_id}>
  //       {name}
  //     </Tag>
  //   );
  // }

  function renderPriorityColor(priority_id) {
    let color;
    switch (priority_id) {
      case 0: {
        color = "#CFD8DC";
        break;
      }
      case 1: {
        color = "#2D9CDB";
        break;
      }
      case 2: {
        color = "#F2994A";
        break;
      }
      case 3: {
        color = "#EB5757";
        break;
      }
      default:
        color = "white";
    }

    return (
      <div
        style={{
          marginLeft: "90%",
          backgroundColor: color,
          width: "15%",
          color: color,
          borderRadius: "10px 0 0 10px",
          lineHeight: "30px",
        }}
        key={priority_id}
      >
        |
      </div>
    );
  }

  function compareByAlph(a, b) {
    if (a > b) {
      return -1;
    }
    if (a < b) {
      return 1;
    }
    return 0;
  }

  const notShowStatuses = ["CONCLUÍDO"];

  const getReport = async () => {
    setIsLoading(true);
    try {
      const [columnsResponse] = await Promise.all([
        StatusesRoutes.getStatus(userStore.companyId, userStore.subprojectId),
      ]);

      const columnsData = columnsResponse.data.data;
      const filteredColumns = columnsData.filter(
        (col) => !notShowStatuses.includes(col.default_name),
      );
      const tasksByStatusMapTemp = {};
      setColumns(filteredColumns);

      await Promise.all(
        filteredColumns.map(async (status) => {
          const response = await TaskRoutes.listByStatus(
            userStore.subprojectId,
            userStore.userId,
            status.id,
            1,
            20,
            false,
          );

          const resData = response.data.data;

          const formattedTasks = resData.data.map((task) => ({
            ...task,
            observers_quantity: task.observer_ids.length,
            key: task.id,
          }));

          tasksByStatusMapTemp[status.id] = {
            tasks: formattedTasks,
            page: resData.page,
            perPage: resData.perPage,
            total: resData.total,
            hasMore: resData.hasMore,
            status,
          };
        }),
      );

      const newGroups = Object.values(tasksByStatusMapTemp).map((entry) => {
        const { status, tasks, total, page, perPage, hasMore } = entry;

        return {
          key: status.id,
          name: `${status.name || status.default_name} (${total})`,
          sequence: status.sequence,
          data: tasks,
          page: page,
          perPage: perPage,
          total: total,
          hasMore: hasMore,
        };
      });

      const allTaskIds = newGroups.flatMap((group) =>
        group.data.map((task) => task.id),
      );

      const idsOptions = allTaskIds.map((id) => (
        <Option key={id} value={id}>
          {id}
        </Option>
      ));
      setIdList(idsOptions);

      newGroups.sort((a, b) => a.sequence - b.sequence);

      setGroupedTasks(newGroups);
      // group(tasksByStatusMapTemp);
    } catch (error) {
      setGroupedTasks([]);
      setError({ message: error.message, hasError: true });
    } finally {
      setIsLoading(false);
    }
  };

  // async function getReportApagar() {
  //   setIsLoading(true);
  //   try {
  //     const params = { subprojects: userStore.subprojectId };
  //     async function getTasks() {
  //       const res = await TaskRoutes.getReport(companyId, params);
  //       const tasks = await res.data.data.data;

  //       const tasksUserResponsibleOrObserver = tasks.filter(
  //         (task) =>
  //           task.responsible_id == userStore.userId ||
  //           task.observers.find(
  //             (observer) => observer.user_id == userStore.userId,
  //           ),
  //       );
  //       const ids = await tasks.map((item) => (
  //         <Option key={item.id} value={item.id}>
  //           {item.id}
  //         </Option>
  //       ));
  //       const idsUserResponsibleOrObserver =
  //         await tasksUserResponsibleOrObserver.map((item) => (
  //           <Option key={item.id} value={item.id}>
  //             {item.id}
  //           </Option>
  //         ));

  //       setIdList([idsUserResponsibleOrObserver]);
  //       setAllIdList([ids]);
  //       setTasks(tasksUserResponsibleOrObserver);
  //       setAllTasks(tasks);
  //       if (checkedAllTasks) {
  //         await group(tasks);
  //         return;
  //       }
  //       await group(tasksUserResponsibleOrObserver);
  //     }

  //     getTasks();
  //   } catch (err) {
  //     setToast({
  //       type: "error",
  //       title: "Erro!",
  //       message: "Um erro ocorreu ao gerar o relatório!",
  //       show: true,
  //       autohide: true,
  //     });
  //   }
  //   setIsLoading(false);
  // }

  useEffect(() => {
    // getReportApagar();
    getReport();
  }, [reload]);

  // useEffect(() => {
  //   async function getStatus() {
  //     const res = await StatusesRoutes.getStatus(
  //       userStore.companyId,
  //       userStore.subprojectId,
  //     );
  //     setStatuses(res.data.data);
  //   }
  //   getStatus();
  // }, []);

  useEffect(() => {
    // if (!selectedId) return;

    const filtered = groupedTasks
      .map((g) => ({
        ...g,
        data: g.data.filter((t) => t.id === selectedId),
      }))
      .filter((g) => g.data.length > 0);

    if (filtered.length > 0) {
      setGroupedTasks(filtered);
    } else {
      getReport();
    }
  }, [selectedId]);

  function expandedRowRender(record) {
    return (
      <Table
        rowKey={(record) => record.id}
        dataSource={record.data}
        rowClassName={() => "rowExpandedClassName"}
        columns={initialColumns}
        pagination={{
          showSizeChanger: false,
          current: record.page,
          pageSize: 20,
          total: record.total,
          onChange: (page) => fetchMoreTasks(record.key, page),
          position: ["bottomCenter"],
        }}
        locale={{ emptyText: "Sem dados para exibir" }}
        onRow={handleOnRow}
      />
    );
  }

  async function fetchMoreTasks(statusId, page) {
    const response = await TaskRoutes.listByStatus(
      userStore.subprojectId,
      userStore.userId,
      statusId,
      page,
      20,
      false,
    );
    const resData = response.data.data;

    setGroupedTasks((prev) =>
      prev.map((group) =>
        group.key === statusId
          ? {
              ...group,
              data: resData.data.map((task) => ({
                ...task,
                key: task.id,
              })),
              page: resData.page,
              perPage: resData.perPage,
              total: resData.total,
            }
          : group,
      ),
    );
  }

  // async function group(tasks) {
  //   setIsLoading(true);

  //   let group = tasks.reduce((r, a) => {
  //     r[a[`${"status_id"}`]] = [...(r[a[`${"status_id"}`]] || []), a];
  //     return r;
  //   }, {});

  //   if (selectedId == undefined) {
  //   } else if (!isArray(selectedId)) {
  //     const taskFiltered = Object.values(group)
  //       .flat()
  //       .find((item) => item.id == selectedId);
  //     setGroupedTasks([]);
  //     setTaskFiltered([taskFiltered]);
  //     setIsLoading(false);
  //     return;
  //   }
  //   const newGroup = [];

  //   for (const g in group) {
  //     const name = group[g][0].status_name;
  //     const sequence = group[g][0].status_sequence;
  //     const length = `: ${group[g].length}`;

  //     newGroup.push({
  //       key: g,
  //       name: name ? name + length : `Sem ${"Status".toLowerCase()}` + length,
  //       data: group[g],
  //       sequence: sequence,
  //     });

  //     newGroup.sort((a, b) => {
  //       if (a.sequence > b.sequence) return 1;
  //       if (a.sequence < b.sequence) return -1;
  //       return 0;
  //     });
  //   }

  //   setGroupedTasks(newGroup);

  //   setIsLoading(false);
  // }

  const reloadListView = async () => {
    try {
      setReload(() => true);
    } catch (error) {
      setError({ message: error.message, hasError: true });
    }
  };

  async function handleTaskValueChange(name, item, taskId, update) {
    const task = selectedTask;

    if (task) {
      task[name] = item;

      if (update) {
        try {
          const taskToUpdate = getTask(task);
          taskToUpdate.status_id = taskToUpdate.status.id;

          await TaskRoutes.updateTask(
            taskToUpdate,
            taskId,
            taskToUpdate.subproject_id,
          );

          setSelectedTask((e) => ({ ...e, ...task }));
          getReport();
        } catch (err) {
          setToast({
            type: "error",
            title: "Erro!",
            message: "Um erro ocorreu alterar o status da tarefa!",
            show: true,
            autohide: true,
          });
        }
      }

      return true;
    }
  }

  async function handleTaskEdit(id) {
    const res = await TaskRoutes.getTask(userStore.subprojectId, id);
    const taskData = res.data.data;
    setTaskEditingData(taskData);
    setModalState(true);
  }

  // async function switchAllTasksFilter(e) {
  //   let colorLabel = e ? "#1890ff" : "grey";
  //   setSwitchLabelColor(colorLabel);
  //   setCheckedAllTasks(e);
  //   if (!isArray(selectedId)) {
  //     if (selectedId != undefined) {
  //     } else {
  //       if (e) {
  //         group(allTasks);
  //       } else {
  //         group(tasks);
  //       }
  //     }
  //   } else {
  //     if (e) {
  //       group(allTasks);
  //     } else {
  //       group(tasks);
  //     }
  //   }
  // }

  return (
    <>
      <ToastComponent
        delay="5000"
        title="Ops! Houve um erro"
        description={error.message}
        type="error"
        showToast={error.hasError}
        handleClose={handleClose}
      />
      <div className="d-flex justify-content-between mb-3 ">
        <div className="d-flex ">
          <Breadcrumb routeToBack={backRoute} className={"align-middle"} />
          <button
            className="button-kanban"
            onClick={() => push(`/home/projects/kanban`)}
          >
            <span>
              <ProjectOutlined className="align-middle mr-0" />
            </span>{" "}
            Kanban
          </button>
          <button
            className="button-kanban"
            onClick={() => push(`/home/projects/calendar`)}
          >
            <span>
              <CalendarOutlined className="align-middle mr-0" />
            </span>{" "}
            Agenda
          </button>
        </div>

        <div className="d-flex justify-content-between ">
          <CheckPermission slug="criar-tarefa">
            <button className="btn-create " onClick={handleModal}>
              + Nova Tarefa
            </button>
          </CheckPermission>
        </div>
      </div>
      <div className="d-flex">
        <Select
          style={{ width: "300px", alignItems: "end" }}
          placeholder="Filtre por Id"
          onChange={(e) => {
            setSelectedId(e);
          }}
          onClear={() => {
            setSelectedId([]);
          }}
          showSearch
          maxTagCount={1}
          value={selectedId}
          allowClear={true}
        >
          {idList}
          {/* {checkedAllTasks ? [allIdList] : [idList]} */}
        </Select>
        {/* <CheckPermission slug="visualizar-todas-tarefas">
          <div className="pl-0 ml-3 d-flex align-items-center  ">
            <SwitchOption
              onClick={(e) => switchAllTasksFilter(e)}
              checked={checkedAllTasks}
            />
            <p
              className="ml-1"
              style={{
                color: switchLabelColor,
                margin: "auto",
              }}
            >
              <strong>Todas as tarefas</strong>
            </p>
          </div>
        </CheckPermission> */}
      </div>

      <Table
        className="mt-4"
        dataSource={isEmpty(groupedTasks) ? taskFiltered : groupedTasks}
        columns={isEmpty(groupedTasks) ? initialColumns : columnsGrouped}
        rowClassName="rowClassName"
        loading={isLoading}
        expandable={
          !isEmpty(groupedTasks) && {
            expandRowByClick: true,
            expandIcon: ({ expanded }) => {
              if (expanded) return <CaretDownOutlined />;
              return <CaretRightOutlined />;
            },
            expandedRowRender,
          }
        }
        locale={{ emptyText: "Sem dados para exibir" }}
        pagination={false}
        scroll={{ x: 1500 }}
        onRow={isEmpty(groupedTasks) ? handleOnRow : () => {}}
      />

      {modalShow && (
        <DrawerTask
          show={modalShow}
          loading={isTaskDrawerLoading}
          onClose={() => setModalShow(false)}
          data={selectedTask}
          changeTaskValue={handleTaskValueChange}
          handleEditTask={handleTaskEdit}
          //afterSaveForm={getReport}
          //afterAddField={getReport}
        />
      )}

      <Modal
        width="60%"
        className="modal-projects"
        centered
        visible={modalIsOpen}
        onCancel={closeCreateModal}
        title="Editar tarefa"
        okButtonProps={{ hidden: true }}
        cancelButtonProps={{ hidden: true }}
      >
        <ModalCreateTask
          handleClose={closeCreateModal}
          refreshList={reloadListView}
          taskEditingData={taskEditingData}
        />
      </Modal>
    </>
  );
}

export default ListView;
